import {
  MODAL_REQUEST_FINISHED,
  MODAL_REQUEST_SENDING,
  TOGGLE_LEAD_MODAL,
  TOGGLE_LEAD_MODAL_ALERT
} from 'bundles/project/actions/index';

const initialState = { show: false, leadToEdit: null };

const LeadModal = (state = initialState, action) => {
  switch (action.type) {
  case TOGGLE_LEAD_MODAL: {
    const { show, leadToEdit } = action.payload;
    return { show, leadToEdit, requestSending: false };
  }
  case TOGGLE_LEAD_MODAL_ALERT:
    return { ...state, showAlert: action.showAlert, errorMessage: action.errorMessage };
  case MODAL_REQUEST_SENDING:
    return { ...state, requestSending: true };
  case MODAL_REQUEST_FINISHED:
    return { ...state, requestSending: false };
  default:
    return state;
  }
};

export default LeadModal;
